var exports = {
  "S": "copyLink__MVwGz0",
  "Dk": "copyText__2rAFjx",
  "oW": "socialLink__mKMzHh",
};

module.exports = exports;
